import MainTemplate from '@/components/MainTemplate.vue'
import { useAliyunOssUpload } from '@/utils/aliyunOss'
import OSS from 'ali-oss'
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
const { getMd5, uploadAliyunOss } = useAliyunOssUpload()
const prefix = 'https://c.17zuoye.cn/'
import { getOssToken } from '@/apps/assessment/model/api'
import { getAppInfo } from '@/apps/index/models/api'
import { bookCatalog, bookSeries, getBooks } from '@/apps/question/model/api'
import moment from 'moment'
import PublishResult from '../components/publish-result'
import {
  getAliyunToken,
  getCourseBooks,
  getRegions,
  getSchoolList,
  getUploadConfig,
  uploadSubmit,
  uploadSubmitPaper
} from '../model/api'
import { SUBJECT_CHOICE } from '../model/common'

const MAX_RETRY_TIMES = 2
let retryTimes = 0
@Component({
  components: { MainTemplate, PublishResult }
})
export default class SourceUpload extends Vue {
  public fileList: any[] = []
  public labelCol = { span: 2 }
  public wrapperCol = { span: 22 }
  public form: any = {
    colon: false,
    layout: 'horizontal',
    sourceType: '1',
    sourceTitle: '',
    province: undefined,
    city: undefined,
    section: undefined,
    period: undefined,
    subject: undefined,
    series: undefined,
    grade: undefined,
    term: undefined,
    catalog: undefined,
    visible: '3',
    hideAuthor: false
  }
  public paperForm: any = {
    colon: false,
    layout: 'horizontal',
    sourceTitle: '',
    province: undefined,
    city: undefined,
    section: undefined,
    period: undefined,
    subject: undefined,
    series: undefined,
    grade: undefined,
    term: undefined,
    catalog: undefined,
    examType: undefined,
    year: undefined,
    unionExam: false,
    paperLevel: 'NO_ANSWER_ANALYSIS'
  }
  public rules = {
    sourceType: [{ required: true, message: '资源类型不能为空', trigger: ['change', 'blur'] }],
    sourceTitle: [{ required: true, message: '资源标题不能为空', trigger: ['change', 'blur'] }],
    province: [{ required: true, validator: this.checkProvince, trigger: ['change', 'blur'] }],
    period: [{ required: true, message: '学段不能为空', trigger: ['change', 'blur'] }],
    subject: [{ required: true, message: '学科不能为空', trigger: ['change', 'blur'] }],
    series: [{ required: true, validator: this.checkSeries, trigger: ['change', 'blur'] }],
    grade: [{ required: true, message: '年级不能为空', trigger: ['change', 'blur'] }],
    term: [{ required: true, message: '学期不能为空', trigger: ['change', 'blur'] }],
    catalog: [{ required: true, message: '教材目录不能为空', trigger: ['change', 'blur'] }],
    visible: [{ required: true, message: '可见范围必选', trigger: ['change', 'blur'] }]
  }
  public paperRules = {
    sourceTitle: [{ required: true, message: '资源标题不能为空', trigger: ['change', 'blur'] }],
    period: [{ required: true, message: '学段不能为空', trigger: ['change', 'blur'] }],
    subject: [{ required: true, message: '学科不能为空', trigger: ['change', 'blur'] }],
    grade: [{ required: true, message: '年级不能为空', trigger: ['change', 'blur'] }],
    term: [{ required: true, message: '学期不能为空', trigger: ['change', 'blur'] }],
    visible: [{ required: true, message: '可见范围必选', trigger: ['change', 'blur'] }],
    examType: [{ required: true, message: '考试类型不能为空', trigger: ['change', 'blur'] }],
    year: [{ required: true, message: '年份不能为空', trigger: ['change', 'blur'] }]
  }
  // 资源
  public provinceChoice: any[] = []
  public cityChoice: any[] = []
  public sectionChoice: any[] = []
  public subjectChoice: any[] = SUBJECT_CHOICE
  public seriesChoice: any[] = []
  public gradeChoice: any[] = []
  public treeData: any[] = []
  public success = false
  // 试卷
  public paperProvinceChoice: any[] = []
  public paperCityChoice: any[] = []
  public paperSectionChoice: any[] = []
  public paperSubjectChoice: any[] = SUBJECT_CHOICE
  public paperSeriesChoice: any[] = []
  public paperGradeChoice: any[] = []
  public seriesTreeData: any[] = []
  public paperLoadedKeys: any[] = []
  public schoolChoice: any[] = []
  public yearsChoice: any[] = []
  public periodsExamTypeChoice: any = {}
  public paperLevelChoice: any[] = []
  public isUnionExamChoice: any[] = []

  public schoolList = []
  public allSchoolList = []
  public showSelectSchoolModal = false
  public changeTabIndex = -1
  public tabs = ['A B C D', 'E F G H', 'I J K L', 'M N O P', 'Q R S T', 'U V W X', 'Y Z']
  // 英文首字母数组
  public listABCD: any[] = []
  public listEFGH: any[] = []
  public listIJKL: any[] = []
  public listMNOP: any[] = []
  public listQRST: any[] = []
  public listUVWX: any[] = []
  public listYZ: any[] = []
  // 所选学校值
  public selectdSchoolValue = ''
  // 所选学校的索引
  public selectdSchoolIndex = this.defaultSchoolId || ''
  // 搜索学校名
  public schoolName = ''
  public schoolId = this.defaultSchoolId || ''
  // 通用
  private ossClient: any = null
  private folder: any = null
  private totalListRef = 0
  private loading = false
  private autofillName = true
  private zhongHangId = 'd5bf4a5ff8876b0f0b5a53f91b65c43a' // 中行id

  private get periodSubjects() {
    if (this.form.period && this.form.period.key) {
      const period = SUBJECT_CHOICE.find((n) => {
        return n.value === this.form.period.key
      })
      return period && period.subs
    } else {
      return []
    }
  }

  private get paperPeriodSubjects() {
    if (this.paperForm.period && this.paperForm.period.key) {
      const period = SUBJECT_CHOICE.find((n) => {
        return n.value === this.paperForm.period.key
      })
      return period && period.subs
    } else {
      return []
    }
  }
  private get canIuse() {
    return this.fileList.every((n) => n.progress === 100)
  }
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get defaultSchoolId() {
    return (this.userInfo && this.userInfo.school_id) || ''
  }
  private get canIuseBooks() {
    const period = this.form.period
    const subject = this.form.subject
    const grade = this.form.grade && this.form.grade.key
    const term = this.form.term
    const series = this.form.series
    return period && series && subject && grade && term
  }
  private get canIusePaperSeries() {
    const period = this.paperForm.period
    const subject = this.paperForm.subject
    const grade = this.paperForm.grade && this.paperForm.grade.key
    const term = this.paperForm.term
    return period && subject && grade && term
  }
  private get examTypeChoice() {
    if (this.paperForm.period.key == 1) {
      return this.periodsExamTypeChoice.PRIMARY_SCHOOL
    } else if (this.paperForm.period.key == 2) {
      return this.periodsExamTypeChoice.MIDDLE_SCHOOL
    } else if (this.paperForm.period.key == 3) {
      return this.periodsExamTypeChoice.HIGH_SCHOOL
    } else {
      return []
    }
  }

  private get isZhongHang() {
    return (
      this.userInfo &&
      this.userInfo.customer_ids &&
      this.userInfo.customer_ids.includes(this.zhongHangId)
    )
  }
  // 从那个userinfo中获取默认的省市区，学科，学段
  @Watch('userInfo')
  public onUserChange(val) {
    const subjectId = val.subjects && val.subjects.length > 0 ? val.subjects[0][0] : ''
    const [province, city, section] =
      val.regions && val.regions.length === 3 ? val.regions : [undefined, undefined, undefined]
    const prefixNumber = String(subjectId).substring(0, 1)
    const period: any = SUBJECT_CHOICE.find((n) => {
      return n && n.value === Number(prefixNumber)
    })
    const subject =
      period &&
      period.subs.find((n) => {
        return n && n.value === subjectId
      })

    this.form.province = this.paperForm.province = province
      ? {
          key: province.code,
          label: province.name
        }
      : undefined
    this.form.city = this.paperForm.city = city
      ? {
          key: city.code,
          label: city.name
        }
      : undefined
    this.form.section = this.paperForm.section = section
      ? {
          key: section.code,
          label: section.name
        }
      : undefined
    this.form.period = this.paperForm.period = period
      ? {
          key: period.value,
          label: period.name
        }
      : undefined
    this.form.subject = this.paperForm.subject = subject
      ? {
          key: subject.value,
          label: subject.name
        }
      : undefined
    if (province) {
      this.getRegions(province.code, 'cityChoice', 'paperCityChoice')
    }
    if (city) {
      this.getRegions(city.code, 'sectionChoice', 'paperSectionChoice')
    }
    if (this.paperForm.section && this.paperForm.section.key) {
      this.getAreaSchoolList(this.paperForm.section.key, true)
    }
    this.getBookSeries()
    this.getAppInfo()
  }

  @Watch('fileList')
  public onFileListChange(val) {
    if (val && val.length === 0) {
      this.autofillName = true
    }
  }

  public created() {
    this.getOssToken()
    this.getRegions(undefined, 'provinceChoice', 'paperProvinceChoice')
    this.getUploadConfig()
  }

  public async getUploadConfig() {
    const year = moment().format('yyyy')
    try {
      const data: any = await getUploadConfig()
      this.yearsChoice = data.study_years && data.study_years[0]
      this.periodsExamTypeChoice = data.periods_exam_types
      this.paperLevelChoice = data.paper_level
      this.isUnionExamChoice = data.is_union_exam
      let curYearChoice = this.yearsChoice.find((n) => {
        let arr = n.value.split('-')
        return arr[0] === String(year)
      })
      // console.log(curYearChoice)
      this.paperForm.year = curYearChoice && curYearChoice.value
    } catch (e) {
      console.log(e)
    }
  }
  // 获取学校
  public async getAreaSchoolList(code, extra?) {
    const period = this.paperForm.period && this.paperForm.period.key
    try {
      const { data, success }: any = await getSchoolList({
        region_codes: String(code),
        school_level: period === 3 ? 4 : period,
        school_name: this.schoolName
      })
      if (success) {
        this.schoolList = data
        // 按照首字母排序
        this.allSchoolList =
          data && data.sort((a, b) => (a.letters[0] + '').localeCompare(b.letters[0] + ''))
        // 全部展示所有学校
        if (this.changeTabIndex === -1) this.schoolList = this.allSchoolList
        // 按字母筛选数组
        this.allSchoolList.forEach((item: any) => {
          if (['A', 'B', 'C', 'D'].includes(item.letters[0])) {
            this.listABCD.push(item)
          } else if (['E', 'F', 'G', 'H'].includes(item.letters[0])) {
            this.listEFGH.push(item)
          } else if (['I', 'J', 'K', 'L'].includes(item.letters[0])) {
            this.listIJKL.push(item)
          } else if (['M', 'N', 'O', 'P'].includes(item.letters[0])) {
            this.listMNOP.push(item)
          } else if (['Q', 'R', 'S', 'T'].includes(item.letters[0])) {
            this.listQRST.push(item)
          } else if (['U', 'V', 'W', 'X'].includes(item.letters[0])) {
            this.listUVWX.push(item)
          } else if (['Y', 'Z'].includes(item.letters[0])) {
            this.listYZ.push(item)
          }
        })
        if (extra) {
          const defaultSchool: any = this.schoolList.find((n: any) => n.id === this.defaultSchoolId)
          this.selectdSchoolValue = this.schoolName = defaultSchool.cname
        }
      } else {
        this.schoolList = []
      }
    } catch (e) {
      console.log(e)
      this.schoolList = []
    }
  }
  // 选择全部学校函数
  public changeTabAll() {
    this.changeTabIndex = -1
    // 展示全部学校
    this.schoolList = this.allSchoolList
  }
  // 选择拼音首字母学校函数
  public changeTab(item, index) {
    this.changeTabIndex = index
    // 去掉空格
    const str = item.replace(/\s+/g, '')
    // 更改当前所选数据
    this.schoolList = this[`list${str}`]
  }
  // 搜索学校
  public onSearch() {
    this.getAreaSchoolList(this.paperForm.section.key)
  }
  // 选择学校
  public selectdSchool(item) {
    this.selectdSchoolValue = item.cname
    // 学校名字
    this.schoolName = item.cname
    // 学校id
    this.schoolId = item.id
    // 学校索引赋值
    this.selectdSchoolIndex = item.id
    this.showSelectSchoolModal = false
  }
  //
  public handleSelectSourceType(val) {
    this.getAppInfo()
    if (val === '2') {
      ;(this.$refs.ruleForm as any).clearValidate()
      this.getPaperBookSeries()
    } else {
      this.getBookSeries()
    }
  }
  //  省 市 区
  public async getRegions(code?: number, list?, extra?) {
    try {
      const { data, success }: any = await getRegions({ region_code: code })
      if (success) {
        this[list] = data.map((n) => {
          return {
            key: n.code,
            label: n.name
          }
        })
        if (extra) {
          this[extra] = this[list]
        }
      } else {
        this[list] = []
      }
    } catch (err) {
      this[list] = []
    }
  }
  // 省
  public handleSelectRegion(data) {
    const { key, label } = data

    this.form.city = undefined
    this.form.section = undefined
    this.cityChoice = []
    this.sectionChoice = []
    this.form.province = {
      key,
      label: String(label).trim()
    }

    this.getRegions(key, 'cityChoice')
  }
  // 省
  public handleSelectPaperRegion(data) {
    const { key, label } = data

    this.paperForm.city = undefined
    this.paperForm.section = undefined
    this.paperCityChoice = []
    this.paperSectionChoice = []
    this.paperForm.province = {
      key,
      label: String(label).trim()
    }

    this.selectdSchoolValue = ''
    this.changeTabIndex = -1
    this.selectdSchoolIndex = ''
    this.schoolName = ''
    this.schoolId = ''

    this.getRegions(key, 'paperCityChoice')
  }
  // 市
  public handleSelectCity(data) {
    const { key, label } = data

    this.form.section = undefined
    this.sectionChoice = []
    this.form.city = {
      key,
      label: String(label).trim()
    }

    this.getRegions(key, 'sectionChoice')
  }
  // 市
  public handleSelectPaperCity(data) {
    const { key, label } = data

    this.paperForm.section = undefined
    this.paperSectionChoice = []
    this.paperForm.city = {
      key,
      label: String(label).trim()
    }

    this.selectdSchoolValue = ''
    this.changeTabIndex = -1
    this.selectdSchoolIndex = ''
    this.schoolName = ''
    this.schoolId = ''

    this.getRegions(key, 'paperSectionChoice')
  }
  // 区
  public handleSelectSection(data) {
    const { key, label } = data
    this.form.section = {
      key,
      label: String(label).trim()
    }
  }
  // 区
  public handleSelectPaperSection(data) {
    const { key, label } = data
    this.paperForm.section = {
      key,
      label: String(label).trim()
    }
    this.selectdSchoolValue = ''
    this.selectdSchoolIndex = ''
    this.schoolName = ''
    this.schoolId = ''
    // 切换到全部
    this.changeTabIndex = -1

    // 置空
    this.listABCD = []
    this.listEFGH = []
    this.listIJKL = []
    this.listMNOP = []
    this.listQRST = []
    this.listUVWX = []
    this.listYZ = []
    // 获取区所在的学校
    this.getAreaSchoolList(key)
  }
  // 学段
  public handleSelectPeriod(data) {
    this.form.period = data
    this.form.subject = undefined
    this.form.grade = undefined
    this.gradeChoice = []
    this.form.series = undefined
    this.form.catalog = undefined
  }
  // 试卷学段
  public handleSelectPaperPeriod(data) {
    this.paperForm.period = data
    this.paperForm.subject = undefined
    this.paperForm.grade = undefined
    this.paperGradeChoice = []
    this.paperForm.series = undefined
    this.paperForm.catalog = undefined
    this.paperForm.examType = undefined
  }
  // 教材系列
  public handleSelectSeries(data) {
    this.form.series = data
    // 重置目录
    this.form.catalog = undefined
    this.getCourseBooks()
  }
  // 年级
  public handleSelectGrade(data) {
    this.form.grade = data
    this.form.catalog = undefined
    this.getCourseBooks()
  }
  // 试卷年级
  public handleSelectPaperGrade(data) {
    this.paperForm.grade = data
    this.paperForm.catalog = undefined
    this.getPaperBookSeries()
  }
  // 学科
  public handleSelectSubject(data) {
    this.form.series = undefined
    this.form.catalog = undefined
    this.form.subject = data
    // 获取教材系列
    this.getBookSeries()
    // 获取年级
    this.getAppInfo()
  }
  // 试卷学科
  public handleSelectPaperSsubject(data) {
    this.paperForm.series = undefined
    this.paperForm.catalog = undefined
    this.paperForm.examType = undefined
    this.paperForm.subject = data
    // 获取试卷教材系列
    this.getPaperBookSeries()
    // 获取年级
    this.getAppInfo()
  }
  // 学期
  public handleSelectTerm() {
    this.form.catalog = undefined
    this.getCourseBooks()
  }
  // 试卷学期
  public handlePaperSelectTerm() {
    this.paperForm.catalog = undefined
    this.getPaperBookSeries()
  }
  // 获取阿里云上传token
  public async getOssToken() {
    try {
      const data: any = await getAliyunToken()
      if (data && Object.keys(data).length > 0) {
        console.log(data)
        const client = new OSS({
          region: data.Region,
          accessKeyId: data.AccessKeyId,
          accessKeySecret: data.AccessKeySecret,
          stsToken: data.SecurityToken,
          bucket: data.Bucket
        })
        this.ossClient = client
        this.folder = data.Folder
      }
    } catch (e) {
      this.$message.warning({
        content: '获取上传密钥失败，请检查网络，刷新后重新上传！',
        duration: 5
      })
    }
  }

  public uploadFile(file: any) {
    console.log(file)
    if (this.autofillName) {
      this.form.sourceTitle = file.name
      this.paperForm.sourceTitle = file.name
      this.autofillName = false
    }
    const uid = file && file.uid
    Promise.all([this.ossClient, getMd5(file)])
      .then(async ([oss, md5]: Array<any>) => {
        const originalFileName = file.name || ''
        let surfix = ''
        if (originalFileName.indexOf('.') > -1) {
          surfix = originalFileName.split('.').pop()
        }
        const newName = this.folder + (surfix ? `${md5}.${surfix}` : md5)
        const newUploadingItem = {
          file,
          client: oss,
          tempCheckpoint: undefined,
          filename: newName,
          // 其他
          name: originalFileName,
          cb: (p) => {
            // 更新上传进度
            let file = this.fileList.find((n) => n.uid === uid)
            if (file) {
              file.progress = ~~(p * 100)
              // 刷新列表中的数据
              this.fileList = [...this.fileList]
            } else {
              return
            }
          }
        }
        uploadAliyunOss(newUploadingItem)
          .then(() => {
            let file = this.fileList.find((n) => n.uid === uid)
            if (file) {
              file.url = prefix + newName
              file.progress = 100
            }
          })
          .catch((e) => {
            // 如果失败
            if (retryTimes <= MAX_RETRY_TIMES) {
              retryTimes++
              this.reUpload(file)
            } else {
              file.progress = -100
              this.fileList = [...this.fileList]
              // 强制刷新
              // window.removeEventListener('beforeunload', this.actBeforeUnload, false)
              location.reload()
            }
          })
      })
      .catch((e) => {
        console.log(e)
      })
  }
  // 客制化上传服务，利用action中的file构造一个列表，
  public async customRequest(action: any) {
    // 给文件追加进度、和链接两个属性
    action.file.progress = 0
    action.file.url = ''
    // 文件放到上传列表中
    this.fileList = [...this.fileList, action.file]
    const length = this.fileList.length
    // 大于10个截取前10并给出提示
    if (length >= 11) {
      if (length === 11) {
        this.$message.warning({
          content: '单次只能上传10个文件，系统已自动截取前10个文件进行上传',
          duration: 5
        })
        // 只保留数组的前10项
        this.fileList.splice(10)
        return
      }
    }
    const file = action.file
    try {
      this.uploadFile(file)
    } catch (e) {
      console.log(e)
    } finally {
      // this.loading = false
    }
  }
  public handleChange(info) {}
  public imageUrl(name) {
    const arr = name.split('.')
    const fileType = arr[arr.length - 1]
    // word
    if (['doc', 'docx'].includes(fileType)) {
      return require(`@/assets/svg/word.svg`)
      // ppt
    } else if (['ppt', 'pptx'].includes(fileType)) {
      return require(`@/assets/svg/ppt.svg`)
      // mp4
    } else if (['mp4', 'wmv', 'rmvb'].includes(fileType)) {
      return require(`@/assets/svg/mp4.svg`)
      // mp3
    } else if (['wav', 'mp3'].includes(fileType)) {
      return require(`@/assets/svg/mp3.svg`)
      // 文件类型
    } else if (fileType) {
      try {
        return require(`@/assets/svg/${fileType}.svg`)
      } catch (e) {
        return require(`@/assets/svg/file.svg`)
      }
      return require(`@/assets/svg/${fileType}.svg`)
      // 兼容类型
    } else {
      return require(`@/assets/svg/file.svg`)
    }
  }
  // 从列表中删除一个文件
  public deleteFile(file, idx) {
    this.$confirm({
      okText: '删除',
      title: '确定删除此资源？',
      content: (h) => {
        return ''
      },
      maskClosable: false,
      keyboard: false,
      onOk: () => {
        this.fileList.splice(idx, 1)
      }
    })
  }
  // 上传失败，重新上传该文件
  public async reUpload(file) {
    const data: any = await getAliyunToken()
    if (data && Object.keys(data).length > 0) {
      console.log(data)
      const client = new OSS({
        region: data.Region,
        accessKeyId: data.AccessKeyId,
        accessKeySecret: data.AccessKeySecret,
        stsToken: data.SecurityToken,
        bucket: data.Bucket
      })
      this.ossClient = client
      this.folder = data.Folder
    }
    this.uploadFile(file)
  }
  // 获取教材系列
  public async getBookSeries() {
    try {
      const { data, success }: any = await bookSeries({ subject_id: this.form.subject.key })
      if (success) {
        this.seriesChoice = data.map((n) => {
          return {
            key: n.id,
            label: n.name
          }
        })
      } else {
        this.seriesChoice = []
      }
    } catch (e) {
      console.log(e)
      this.seriesChoice = []
    }
  }
  // 获取试卷上传教材系列
  public async getPaperBookSeries() {
    try {
      this.seriesTreeData = []
      this.paperLoadedKeys = []
      const { data, success }: any = await bookSeries({ subject_id: this.paperForm.subject.key })
      if (success) {
        this.seriesTreeData =
          data &&
          data.map((n) => {
            const result = {
              selectable: false,
              isLeaf: !n.has_child,
              key: n.id,
              title: n.name,
              value: n.id
            }
            return result
          })
      } else {
        this.seriesTreeData = []
      }
    } catch (e) {
      console.log(e)
      this.seriesTreeData = []
    }
  }
  // 获取年级
  public async getAppInfo() {
    const subject_id =
      this.form.sourceType === '1' ? this.form.subject.key : this.paperForm.subject.key
    try {
      const { data, success }: any = await getAppInfo({ subject_id })
      if (success) {
        this.gradeChoice = data.grade_choices.filter((n) => n && n[1] !== '全部')
        this.paperGradeChoice = this.gradeChoice
      } else {
        this.gradeChoice = []
        this.paperGradeChoice = []
      }
    } catch (e) {
      this.gradeChoice = []
      this.paperGradeChoice = []
    }
  }
  // 获取书册
  public async getCourseBooks() {
    if (!this.form.series) return
    if (!this.form.grade) return
    if (!this.form.term) return
    try {
      const params = {
        series_id: Number(this.form.series.key),
        grade: Number(this.form.grade.key),
        term: Number(this.form.term)
      }
      const { data, success }: any = await getCourseBooks(params)
      if (success) {
        this.treeData =
          data &&
          data.map((n) => {
            const result = {
              selectable: false,
              isLeaf: false,
              key: n.id,
              title: n.name,
              value: n.id
            }
            return result
          })
      }
    } catch (e) {}
  }
  // 获取教材下面的章节
  public async onLoadData(treeNode) {
    // console.log(treeNode)
    const { value } = treeNode.dataRef
    const params = {
      parent_id: value
    }
    try {
      const { data, success }: any = await bookCatalog(params)
      if (success) {
        const children = data.map((n) => {
          const result = {
            selectable: true,
            isLeaf: !n.has_child,
            key: n.id,
            title: n.name,
            value: n.id
          }
          return result
        })
        treeNode.dataRef.children = children
        this.treeData = [...this.treeData]
      }
    } catch (e) {
      console.log(e)
    }
  }
  // 获取试卷教材下面的教材章节
  public async onLoadPaperData(treeNode) {
    const { value } = treeNode.dataRef
    const params = {
      series_id: value,
      grade: Number(this.paperForm.grade.key),
      term: Number(this.paperForm.term)
    }
    try {
      const { data, success }: any = await getCourseBooks(params)
      if (success) {
        const children = data.map((n) => {
          const result = {
            selectable: true,
            isLeaf: true,
            key: n.id,
            title: n.name,
            value: n.id
          }
          return result
        })
        treeNode.dataRef.children = children
        this.seriesTreeData = [...this.seriesTreeData]
      }
    } catch (e) {
      console.log(e)
    }
  }
  // 点击发布按钮提交表单
  public handleSubmit() {
    if (!this.canIuse) {
      this.$message.warning({
        content: '请待全部文件上传完成，再发布',
        duration: 3
      })
      return
    }
    const ref: any = this.$refs.ruleForm
    // tslint:disable-next-line:cyclomatic-complexity
    ref.validate(async (valid) => {
      if (valid) {
        const name = this.form.sourceTitle || ''
        const doc_type = Number(this.form.sourceType)
        const region = {
          province_name:
            this.form.province && this.form.province.label ? this.form.province.label : undefined,
          province_id:
            this.form.province && this.form.province.key ? this.form.province.key : undefined,
          city_name: this.form.city && this.form.city.label ? this.form.city.label : undefined,
          city_id: this.form.city && this.form.city.key ? this.form.city.key : undefined,
          region_name:
            this.form.section && this.form.section.label ? this.form.section.label : undefined,
          region_id: this.form.section && this.form.section.key ? this.form.section.key : undefined
        }
        const study_period = this.form.period && Number(this.form.period.key)
        const subject_id = this.form.subject && Number(this.form.subject.key)
        const series_id = this.form.series && Number(this.form.series.key)
        const term = Number(this.form.term)
        const book_catalog = Number(this.form.catalog)
        const visible_type = Number(this.form.visible)
        const hide_author = this.form.hideAuthor ? 1 : 0
        const attachments = this.fileList.map((n) => {
          const result = {
            name: n.name,
            url: n.url,
            size: n.size
          }
          return result
        })
        const grade = Number(this.form.grade.key)
        const params: any = {
          doc_type,
          name,
          region,
          study_period,
          subject_id,
          series_id,
          term,
          book_catalog,
          visible_type,
          hide_author,
          grade,
          attachments
        }
        try {
          this.loading = true
          const { data, success, msg }: any = await uploadSubmit(params)
          if (success) {
            // 发布成功
            this.success = success
          } else {
            // 发布失败
            this.$message.warning(msg)
          }
        } catch (e) {
          console.log(e)
          // 报错
        } finally {
          this.loading = false
        }
      }
    })
  }
  // 点击上传试卷的已发布
  public handleSubmitPaper() {
    if (!this.canIuse) {
      this.$message.warning({
        content: '请待全部文件上传完成，再发布',
        duration: 3
      })
      return
    }
    const ref: any = this.$refs.ruleFormPaper
    ref.validate(async (valid) => {
      if (valid) {
        const name = this.paperForm.sourceTitle || ''
        const doc_type = Number(this.paperForm.sourceType)
        const region = {
          province_name:
            this.paperForm.province && this.paperForm.province.label
              ? this.paperForm.province.label
              : undefined,
          province_id:
            this.paperForm.province && this.paperForm.province.key
              ? this.paperForm.province.key
              : undefined,
          city_name:
            this.paperForm.city && this.paperForm.city.label
              ? this.paperForm.city.label
              : undefined,
          city_id:
            this.paperForm.city && this.paperForm.city.key ? this.paperForm.city.key : undefined,
          region_name:
            this.paperForm.section && this.paperForm.section.label
              ? this.paperForm.section.label
              : undefined,
          region_id:
            this.paperForm.section && this.paperForm.section.key
              ? this.paperForm.section.key
              : undefined
        }
        const study_period = this.paperForm.period && Number(this.paperForm.period.key)
        const subject_id = this.paperForm.subject && Number(this.paperForm.subject.key)
        const term = Number(this.paperForm.term)
        const book_catalog = Number(this.paperForm.catalog)
        const is_union_exam = Boolean(this.paperForm.unionExam)
        const paper_level = String(this.paperForm.paperLevel)
        const exam_type = Number(this.paperForm.examType)
        const study_year = String(this.paperForm.year)
        const attachments = this.fileList.map((n) => {
          return n.url
        })
        const school = {
          id: this.schoolId,
          name: this.selectdSchoolValue
        }
        const grade = this.paperForm.grade && this.paperForm.grade.key
        const params: any = {
          doc_type,
          name,
          region,
          study_period,
          subject_id,
          grade,
          term,
          book_catalog,
          is_union_exam,
          paper_level,
          exam_type,
          study_year,
          school,
          attachments
        }
        try {
          this.loading = true
          const { data, success, error }: any = await uploadSubmitPaper(params)
          if (success) {
            this.success = success
          } else {
            this.$message.warning(error)
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      }
    })
  }
  // 自定义表单校验
  public checkProvince(rule, value, callback) {
    if (value && value.key) {
      callback()
    } else {
      callback('省份不能为空')
    }
  }
  public checkSeries(rule, value, callback) {
    if (value && value.key) {
      callback()
    } else {
      callback('教材系列不能为空')
    }
  }

  public getPopupContainer() {
    return this.$refs.form
  }

  public actBeforeUnload(e) {
    const event = e || window.event
    const message = '当前资源尚未发布成功，关闭或离开页面将不能保存资源信息，是否确认离开？'
    event.preventDefault()
    event.returnValue = message
  }

  public mounted() {
    window.addEventListener('beforeunload', this.actBeforeUnload, false)
  }

  public beforeDestroy() {
    window.removeEventListener('beforeunload', this.actBeforeUnload, false)
  }
}
